import bullsLogo from "../assets/images/rivalry/bulls.jpg";
import lionsLogo from "../assets/images/rivalry/lions.jpg";
import sharksLogo from "../assets/images/rivalry/sharks.jpg";
import stormersLogo from "../assets/images/rivalry/stormers.jpg";

import splashLogo from "../assets/images/raz/splashlogo.png";

import argentinaFlag from "../assets/images/flags/argentina.jpg";
import australiaFlag from "../assets/images/flags/australia.jpg";
import englandFlag from "../assets/images/flags/england.png";
import fijiFlag from "../assets/images/flags/fiji.jpg";
import franceFlag from "../assets/images/flags/france.jpg";
import irelandFlag from "../assets/images/flags/ireland.jpg";
import italyFlag from "../assets/images/flags/italy.jpg";
import japanFlag from "../assets/images/flags/japan.jpg";
import nzFlag from "../assets/images/flags/new-zealand.jpg";
import portugalFlag from "../assets/images/flags/portugal.jpg";
import romaniaFlag from "../assets/images/flags/romania.jpg";
import samoaFlag from "../assets/images/flags/samoa.jpg";
import scotlandFlag from "../assets/images/flags/scotland.jpg";
import southAfricaFlag from "../assets/images/flags/south-africa.jpg";
import spainFlag from "../assets/images/flags/spain.jpg";
import tongaFlag from "../assets/images/flags/tonga.jpg";
import usaFlag from "../assets/images/flags/united-states-of-america.jpg";
import uruguayFlag from "../assets/images/flags/uruguay.jpg";
import walesFlag from "../assets/images/flags/wales.jpg";
import zimbabweFlag from "../assets/images/flags/zimbabwe.jpg";
import chileFlag from "../assets/images/flags/chile.jpg";
import canadaFlag from "../assets/images/flags/canada.jpg";
import georgiaFlag from "../assets/images/flags/georgia.jpg";
import hongKongFlag from "../assets/images/flags/hong-kong-china.jpg";
import polandFlag from "../assets/images/flags/poland.jpg";
import czechRepublicFlag from "../assets/images/flags/czech-republic.jpg";

/* ==================================================
   URC — MEN 2026/27
   ================================================== */

import urcBenetton from "../assets/images/teams/men/urc/benetton.jpg";
import urcBulls from "../assets/images/teams/men/urc/bulls.jpg";
import urcCardiff from "../assets/images/teams/men/urc/cardiff.jpg";
import urcConnacht from "../assets/images/teams/men/urc/connacht.jpg";
import urcDragons from "../assets/images/teams/men/urc/dragons.jpg";
import urcEdinburgh from "../assets/images/teams/men/urc/edinburgh.jpg";
import urcGlasgowWarriors from "../assets/images/teams/men/urc/glasgow-warriors.jpg";
import urcLeinster from "../assets/images/teams/men/urc/leinster.jpg";
import urcLions from "../assets/images/teams/men/urc/lions.jpg";
import urcMunster from "../assets/images/teams/men/urc/munster.jpg";
import urcOspreys from "../assets/images/teams/men/urc/ospreys.jpg";
import urcScarlets from "../assets/images/teams/men/urc/scarlets.jpg";
import urcSharks from "../assets/images/teams/men/urc/sharks.jpg";
import urcStormers from "../assets/images/teams/men/urc/stormers.jpg";
import urcUlster from "../assets/images/teams/men/urc/ulster.jpg";
import urcZebreParma from "../assets/images/teams/men/urc/zebre-parma.jpg";

/* ==================================================
   GALLAGHER PREM — MEN 2026/27
   ================================================== */

import premBath from "../assets/images/teams/men/gallagher-prem/bath.jpg";
import premBristolBears from "../assets/images/teams/men/gallagher-prem/bristol-bears.jpg";
import premExeterChiefs from "../assets/images/teams/men/gallagher-prem/exeter-chiefs.jpg";
import premGloucester from "../assets/images/teams/men/gallagher-prem/gloucester.jpg";
import premHarlequins from "../assets/images/teams/men/gallagher-prem/harlequins.jpg";
import premLeicesterTigers from "../assets/images/teams/men/gallagher-prem/leicester-tigers.jpg";
import premNewcastleRedBulls from "../assets/images/teams/men/gallagher-prem/newcastle-red-bulls.jpg";
import premNorthamptonSaints from "../assets/images/teams/men/gallagher-prem/northampton-saints.jpg";
import premSaleSharks from "../assets/images/teams/men/gallagher-prem/sale-sharks.jpg";
import premSaracens from "../assets/images/teams/men/gallagher-prem/saracens.jpg";

/* ==================================================
   EPCR CHALLENGE CUP — MEN 2026/27
   ================================================== */

import epcrBayonne from "../assets/images/teams/men/epcr/bayonne.png";
import epcrBenetton from "../assets/images/teams/men/epcr/benetton.jpg";
import epcrBlackLion from "../assets/images/teams/men/epcr/black-lion.png";
import epcrCastres from "../assets/images/teams/men/epcr/castre.png";
import epcrCheetahs from "../assets/images/teams/men/epcr/cheetahs.png";
import epcrDragons from "../assets/images/teams/men/epcr/dragons.jpg";
import epcrEdinburgh from "../assets/images/teams/men/epcr/edinburgh.jpg";
import epcrHarlequins from "../assets/images/teams/men/epcr/harlequins.jpg";
import epcrLyon from "../assets/images/teams/men/epcr/lyon.png";
import epcrNewcastleRedBulls from "../assets/images/teams/men/epcr/newcastle-red-bulls.jpg";
import epcrOspreys from "../assets/images/teams/men/epcr/ospreys.jpg";
import epcrScarlets from "../assets/images/teams/men/epcr/scarlets.jpg";
import epcrSharks from "../assets/images/teams/men/epcr/sharks.jpg";
import epcrToulon from "../assets/images/teams/men/epcr/toulon.png";
import epcrUlster from "../assets/images/teams/men/epcr/ulster.jpg";
import epcrUsap from "../assets/images/teams/men/epcr/usa-perpignan.png";
import epcrVannes from "../assets/images/teams/men/epcr/vannes.png";
import epcrZebreParma from "../assets/images/teams/men/epcr/zebre-parma.jpg";

/* ==================================================
   INVESTEC CHAMPIONS CUP — MEN 2026/27
   ================================================== */

import investecBath from "../assets/images/teams/men/investec/bath.jpg";
import investecBordeauxBegles from "../assets/images/teams/men/investec/bordeaux-begles.png";
import investecBristolBears from "../assets/images/teams/men/investec/bristol-bears.jpg";
import investecBulls from "../assets/images/teams/men/investec/bulls.jpg";
import investecCardiff from "../assets/images/teams/men/investec/cardiff.jpg";
import investecClermontAuvergne from "../assets/images/teams/men/investec/clermont-auvergne.png";
import investecConnacht from "../assets/images/teams/men/investec/connacht.jpg";
import investecExeterChiefs from "../assets/images/teams/men/investec/exeter-chiefs.jpg";
import investecGlasgowWarriors from "../assets/images/teams/men/investec/glasgow-warriors.jpg";
import investecGloucester from "../assets/images/teams/men/investec/gloucester.jpg";
import investecLaRochelle from "../assets/images/teams/men/investec/la-rochelle.png";
import investecLeicesterTigers from "../assets/images/teams/men/investec/leicester-tigers.jpg";
import investecLeinster from "../assets/images/teams/men/investec/leinster.jpg";
import investecLions from "../assets/images/teams/men/investec/lions.jpg";
import investecMontpellier from "../assets/images/teams/men/investec/montpellier.png";
import investecMunster from "../assets/images/teams/men/investec/munster.jpg";
import investecNorthamptonSaints from "../assets/images/teams/men/investec/northampton-saints.jpg";
import investecPau from "../assets/images/teams/men/investec/pau.png";
import investecRacing92 from "../assets/images/teams/men/investec/racing-92.png";
import investecSaleSharks from "../assets/images/teams/men/investec/sale-sharks.jpg";
import investecSaracens from "../assets/images/teams/men/investec/saracens.jpg";
import investecStadeFrancais from "../assets/images/teams/men/investec/stade-francais.png";
import investecStormers from "../assets/images/teams/men/investec/stormers.jpg";
import investecToulouse from "../assets/images/teams/men/investec/toulouse.png";

/* ==================================================
   BUNNINGS NPC — MEN 2026
   ================================================== */

import npcAucklandBlues from "../assets/images/teams/men/npc/auckland-blues.png";
import npcBayOfPlenty from "../assets/images/teams/men/npc/bay-of-plenty.png";
import npcCanterbury from "../assets/images/teams/men/npc/canterbury.png";
import npcCountiesManukau from "../assets/images/teams/men/npc/counties-manukau.png";
import npcHawkesBay from "../assets/images/teams/men/npc/hawkes-bay.png";
import npcManawatu from "../assets/images/teams/men/npc/manawatu.png";
import npcNorthHarbour from "../assets/images/teams/men/npc/north-harbour.png";
import npcNorthland from "../assets/images/teams/men/npc/northland.png";
import npcOtago from "../assets/images/teams/men/npc/otago.png";
import npcSouthland from "../assets/images/teams/men/npc/southland.png";
import npcTaranaki from "../assets/images/teams/men/npc/taranaki.png";
import npcTasman from "../assets/images/teams/men/npc/tasman.png";
import npcWaikato from "../assets/images/teams/men/npc/waikato.png";
import npcWellington from "../assets/images/teams/men/npc/wellington.png";

/* ==================================================
   GENERAL TEAM IMAGE MAP
   ================================================== */

const TEAM_IMAGES: Record<string, string> = {
  tbd: splashLogo,
  unknown: splashLogo,

  /* South African franchises */

  stormers: stormersLogo,
  sharks: sharksLogo,
  bulls: bullsLogo,
  lions: lionsLogo,

  /* International flags */

  "south africa": southAfricaFlag,
  "new zealand": nzFlag,
  australia: australiaFlag,
  argentina: argentinaFlag,
  japan: japanFlag,
  england: englandFlag,
  france: franceFlag,
  ireland: irelandFlag,
  italy: italyFlag,
  scotland: scotlandFlag,
  spain: spainFlag,
  wales: walesFlag,
  fiji: fijiFlag,
  samoa: samoaFlag,
  tonga: tongaFlag,
  portugal: portugalFlag,
  romania: romaniaFlag,
  uruguay: uruguayFlag,
  chile: chileFlag,
  georgia: georgiaFlag,
  canada: canadaFlag,
  zimbabwe: zimbabweFlag,
  "hong kong china": hongKongFlag,
  usa: usaFlag,
  "united states": usaFlag,
  polska: polandFlag,
  czechy: czechRepublicFlag,
};

/* ==================================================
   URC TEAM IMAGE MAP
   ================================================== */

const URC_TEAM_IMAGES: Record<string, string> = {
  benetton: urcBenetton,
  bulls: urcBulls,
  cardiff: urcCardiff,
  connacht: urcConnacht,
  dragons: urcDragons,
  edinburgh: urcEdinburgh,
  "glasgow warriors": urcGlasgowWarriors,
  leinster: urcLeinster,
  lions: urcLions,
  munster: urcMunster,
  ospreys: urcOspreys,
  scarlets: urcScarlets,
  sharks: urcSharks,
  stormers: urcStormers,
  ulster: urcUlster,
  "zebre parma": urcZebreParma,
};

/* ==================================================
   GALLAGHER PREM TEAM IMAGE MAP
   ================================================== */

const PREM_TEAM_IMAGES: Record<string, string> = {
  bath: premBath,
  "bristol bears": premBristolBears,
  "exeter chiefs": premExeterChiefs,
  gloucester: premGloucester,
  harlequins: premHarlequins,
  "leicester tigers": premLeicesterTigers,
  "newcastle red bulls": premNewcastleRedBulls,
  "northampton saints": premNorthamptonSaints,
  "sale sharks": premSaleSharks,
  saracens: premSaracens,
};

/* ==================================================
   EPCR CHALLENGE CUP TEAM IMAGE MAP
   ================================================== */

const EPCR_TEAM_IMAGES: Record<string, string> = {
  "aviron bayonnais": epcrBayonne,
  "benetton rugby": epcrBenetton,
  "black lion": epcrBlackLion,
  "castres olympique": epcrCastres,
  "toyota cheetahs": epcrCheetahs,
  "dragons rfc": epcrDragons,
  "edinburgh rugby": epcrEdinburgh,
  "harlequins": epcrHarlequins,
  "lou rugby": epcrLyon,
  "newcastle red bulls": epcrNewcastleRedBulls,
  ospreys: epcrOspreys,
  scarlets: epcrScarlets,
  "hollywoodbets sharks": epcrSharks,
  "rc toulon": epcrToulon,
  "ulster rugby": epcrUlster,
  usap: epcrUsap,
  "rc vannes": epcrVannes,
  "zebre parma": epcrZebreParma,
};

/* ==================================================
   INVESTEC CHAMPIONS CUP TEAM IMAGE MAP
   ================================================== */

const INVESTEC_TEAM_IMAGES: Record<string, string> = {
  "bath rugby": investecBath,
  "union bordeaux bègles": investecBordeauxBegles,
  "union bordeaux begles": investecBordeauxBegles,
  "bristol bears": investecBristolBears,
  "vodacom bulls": investecBulls,
  "cardiff rugby": investecCardiff,
  "asm clermont auvergne": investecClermontAuvergne,
  "connacht rugby": investecConnacht,
  "exeter chiefs": investecExeterChiefs,
  "glasgow warriors": investecGlasgowWarriors,
  "gloucester rugby": investecGloucester,
  "stade rochelais": investecLaRochelle,
  "leicester tigers": investecLeicesterTigers,
  "leinster rugby": investecLeinster,
  "10bet lions": investecLions,
  "montpellier hérault rugby": investecMontpellier,
  "montpellier herault rugby": investecMontpellier,
  "munster rugby": investecMunster,
  "northampton saints": investecNorthamptonSaints,
  "section paloise": investecPau,
  "racing 92": investecRacing92,
  "sale sharks": investecSaleSharks,
  saracens: investecSaracens,
  "stade français paris": investecStadeFrancais,
  "stade francais paris": investecStadeFrancais,
  "dhl stormers": investecStormers,
  "stade toulousain": investecToulouse,
};

/* ==================================================
   BUNNINGS NPC TEAM IMAGE MAP
   ================================================== */

const NPC_TEAM_IMAGES: Record<string, string> = {
  auckland: npcAucklandBlues,
  "auckland blues": npcAucklandBlues,
  "bay of plenty": npcBayOfPlenty,
  canterbury: npcCanterbury,
  "counties manukau": npcCountiesManukau,
  "counties manukau rugby": npcCountiesManukau,
  "hawkes bay": npcHawkesBay,
  "hawke's bay": npcHawkesBay,
  manawatu: npcManawatu,
  "manawatu turbos": npcManawatu,
  "north harbour": npcNorthHarbour,
  northland: npcNorthland,
  otago: npcOtago,
  southland: npcSouthland,
  taranaki: npcTaranaki,
  tasman: npcTasman,
  waikato: npcWaikato,
  wellington: npcWellington,
};

/* ==================================================
   TEAM IMAGE RESOLVER
   ================================================== */

export function getTeamImage(
  teamName: string,
  competitionId?: string
): string {
  const key = teamName
    .trim()
    .toLowerCase()
    .replace(/\s+w$/, "");

  /* ==================================================
     URC
     ================================================== */

  if (competitionId === "urc") {
    return URC_TEAM_IMAGES[key] ?? splashLogo;
  }

  /* ==================================================
     GALLAGHER PREM
     ================================================== */

  if (competitionId === "premiership") {
    return PREM_TEAM_IMAGES[key] ?? splashLogo;
  }

  /* ==================================================
     EPCR CHALLENGE CUP
     ================================================== */

  if (competitionId === "challenge-cup") {
    return EPCR_TEAM_IMAGES[key] ?? splashLogo;
  }

  /* ==================================================
     INVESTEC CHAMPIONS CUP
     ================================================== */

  if (competitionId === "champions-cup") {
    return INVESTEC_TEAM_IMAGES[key] ?? splashLogo;
  }

  /* ==================================================
     BUNNINGS NPC
     ================================================== */

  if (competitionId === "npc") {
    return NPC_TEAM_IMAGES[key] ?? splashLogo;
  }

  /* ==================================================
     EXISTING TEAM / INTERNATIONAL RESOLUTION
     ================================================== */

  return TEAM_IMAGES[key] ?? splashLogo;
}